import "./Footer.scss";

import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p className="footer-copyright">
          &copy; | 2021 Developed with passion by Vladyslav Fomenko
        </p>
      </div>
    </footer>
  );
}
